<app-layer-category class="border-bottom border-darkgray" description="Rollouts Map">
  <app-layer-control-item
    description="Signs"
    [isLayerVisibile]="isRolloutsMatchedSignsLayerVisible"
    [layerId]="layerIds.RolloutsMatchedSignsTile.name"
    icon="speedlimit-80-dirty"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>

  <app-layer-control-item
    description="Rollouts"
    [isLayerVisibile]="isRolloutsTileLayerVisible"
    [layerId]="layerIds.RolloutsTile.name"
    icon="car-street"
    (visibilityToggled)="toggleLayerVisbility($event)"
    rbDetailsToggle
    [isOpen]="detailsOpen"
    #triggerDetails="rbDetailsToggle"
  ></app-layer-control-item>

  @if (triggerDetails.open) {
    <div class="dropdown-container" style="min-width: 50px; margin-top: 0">
      <button
        [rbDropdown]="renderOnInitdropdownContent"
        [renderOnInit]="isRolloutsTileLayerVisible"
        class="rb-btn bg-darkgray text-body rb-dropdown-toggle w-100 text-start rounded-2 border-0 fs-xs"
      >
        {{ currentMetric }}
      </button>
      <ng-template #renderOnInitdropdownContent>
        <button
          type="button"
          class="rb-btn rb-link rb-dropdown-item"
          [class.active]="currentMetric === RolloutsMapMetrics.RolloutsMap_SpeedLimit"
          (click)="selectMetric(RolloutsMapMetrics.RolloutsMap_SpeedLimit)"
        >
          {{ RolloutsMapMetrics.RolloutsMap_SpeedLimit }}
        </button>
        <button
          type="button"
          class="rb-btn rb-link rb-dropdown-item"
          [class.active]="currentMetric === RolloutsMapMetrics.RolloutsMap_Probability"
          (click)="selectMetric(RolloutsMapMetrics.RolloutsMap_Probability)"
        >
          {{ RolloutsMapMetrics.RolloutsMap_Probability }}
        </button>
      </ng-template>
    </div>
  }
</app-layer-category>
